import { render } from "./SelectScreenshotsSheet.vue?vue&type=template&id=e5107956"
import script from "./SelectScreenshotsSheet.vue?vue&type=script&lang=js"
export * from "./SelectScreenshotsSheet.vue?vue&type=script&lang=js"

import "./SelectScreenshotsSheet.vue?vue&type=style&index=0&id=e5107956&lang=scss"
script.render = render

export default script